import { PplxError } from '#pplx/frontend/common/errors.js';
export class ReactRenderingError extends PplxError {
    name = 'ReactRenderingError';
}
//# sourceMappingURL=errors.js.map